import { Component, OnInit } from '@angular/core'

import { MainService } from '../service/main.service'

@Component({
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.styl']
})

export class HomeComponent implements OnInit{
	activeItem: object;
	activeIndex: number;
	sideItems: Array<any>;
	workingData: object;
	lionData: object;
	oneshoppingData: object;
	partner_lists: Array<any>;
	star: number = 999;
	end: number = 999;	
	constructor(public mainService: MainService) {		
		this.activeIndex = 1;		

	}
	ngOnInit() {
		this.getData();
	}
	public getData():void{
		this.mainService.getHomeData()
			.subscribe(
				data => {
					this.sideItems = data.sideItems;
					this.activeItem = this.sideItems[0].summay;
					this.workingData = data.workingData;
					this.lionData = data.lionData;
					this.oneshoppingData = data.oneshoppingData;
					this.partner_lists = data.partner_lists;
					this.formatList();
				},
				error => {
					console.log(error)
				}
			);
	}
	public formatList():void{
		let partner_len =  this.partner_lists.length+1;
		if(partner_len%5>0) {
			this.star = partner_len-partner_len%5-(5-partner_len%5)+1;
			this.end = partner_len-partner_len%5;			
		}
	}	
}


// WEBPACK FOOTER //
// C:/Users/Administrator/submit text project/gwin/src/app/home/home.component.ts